/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Overlay from 'react-bootstrap/Overlay';
import { useNavigate } from 'react-router-dom';
import { MdOutlineSwapHoriz, MdOutlineSwapVert } from 'react-icons/md';
import { debounce } from '../../../api/apiUtils';
import {
  getCitiesApi,
  //  getRecentCities
} from '../../../api/busApi';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import {
  formatDate,
  getNewDate,
  isMobileWidth,
  serialize,
} from '../../../shared/helper-utils/appUtils';
import { useAppContext } from '../../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 300;

export function locationOptions(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'location-focused' : ''} location-option`}
      key={props.value}
    >
      <div className="d-flex black-color">
        <div className="d-flex flex-column location-option__other black-color">
          <span className="location-option__other_location black-color p-1">
            {props.label}
          </span>
        </div>
      </div>
    </div>
  );
}

function BusSearch({ previousSearchRequest }) {
  const navigate = useNavigate();
  const { appConfig } = useAppContext();
  const [errors, setErrors] = useState({});
  // const isApiRequestProcessingRef = useRef(false);
  // const [defaultLocationList, setDefaultLocationList] = useState([]);
  const originRef = useRef(null);
  const destinationRef = useRef(null);
  const isMobileView = useRef(false);
  const [search, setSearch] = useState({
    origin: {
      placeid: '',
      place_type: 'bus',
      place_name: '',
    },
    destination: {
      placeid: '',
      place_type: 'bus',
      place_name: '',
    },
    jdate: '',
    agentid: '',
    currency: appConfig?.appCurrency,
    numadults: 1,
    numchildren: 0,
    numinfants: 0,
  });

  const getLabel = (location) => {
    return (
      <div className="d-flex flex-column">
        <span style={{ fontSize: '14px', fontWeight: '600' }}>{location}</span>
      </div>
    );
  };

  useEffect(() => {
    if (previousSearchRequest) {
      originRef.current = {
        label: getLabel(previousSearchRequest.origin.place_name),
        value: previousSearchRequest.origin.placeid,
      };
      destinationRef.current = {
        label: getLabel(previousSearchRequest.destination.place_name),
        value: previousSearchRequest.destination.placeid,
      };
      setSearch((prevState) => ({
        ...prevState,
        origin: {
          ...prevState.origin,
          placeid: previousSearchRequest.origin.placeid,
          place_name: previousSearchRequest.origin.place_name,
        },
        destination: {
          ...prevState.destination,
          placeid: previousSearchRequest.destination.placeid,
          place_name: previousSearchRequest.destination.place_name,
        },
        jdate: getNewDate(previousSearchRequest.jdate),
        numadults: previousSearchRequest.numadults,
        numchildren: previousSearchRequest.numchildren,
        numinfants: previousSearchRequest.numinfants,
      }));
    }
  }, [previousSearchRequest]);

  const handleUpdateSearchState = (name, value) => {
    if (name === 'origin') {
      setSearch((prevState) => ({
        ...prevState,
        origin: {
          ...prevState.origin,
          placeid: value.originValue,
          place_name: value.originlabel,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        origin: undefined,
      }));
    } else if (name === 'destination') {
      setSearch((prevState) => ({
        ...prevState,
        destination: {
          ...prevState.destination,
          placeid: value.destinationValue,
          place_name: value.destinationlabel,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        destination: undefined,
      }));
    } else {
      setSearch((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        jdate: undefined,
      }));
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    handleUpdateSearchState(name, value);
  };

  const loadLocationSuggestions = debounce(async (query, callback) => {
    let cities = [];
    if (query.length >= 3) {
      const response = await getCitiesApi(query);
      response.sort((a, b) => a.locationname.length - b.locationname.length);
      cities = response.map((cityNode) => ({
        label: getLabel(cityNode.locationname),
        value: cityNode.locationcode,
        ...cityNode,
      }));
    }
    callback(cities);
  }, DEBOUNCE_DELAY);

  const handleCitySelect = (city, name) => {
    if (name === 'origin') {
      originRef.current = city;
      let originValue = '';
      let originlabel = '';
      if (city !== null) {
        originValue = city.value;
        originlabel = city.locationname;
      }

      handleUpdateSearchState(name, { originValue, originlabel });
    } else {
      destinationRef.current = city;
      let destinationValue = '';
      let destinationlabel = '';
      if (city !== null) {
        destinationValue = city.value;
        destinationlabel = city.locationname;
      }
      handleUpdateSearchState(name, { destinationValue, destinationlabel });
    }
  };

  const handlePlatformSwap = () => {
    const destinationValue = search.origin.placeid;
    const destinationlabel = search.origin.place_name;
    const originValue = search.destination.placeid;
    const originlabel = search.destination.place_name;
    const tempOriginRef = originRef.current;
    handleUpdateSearchState('origin', { originValue, originlabel });
    handleUpdateSearchState('destination', {
      destinationValue,
      destinationlabel,
    });
    originRef.current = destinationRef.current;
    destinationRef.current = tempOriginRef;
  };

  const handleDateChange = (date, fieldName) => {
    handleUpdateSearchState(fieldName, date);
  };

  const handleBusSearch = () => {
    const errorsObj = {};
    if (search.origin.placeid === '') {
      errorsObj.origin = 'Please select origin.';
    }
    if (search.destination.placeid === '') {
      errorsObj.destination = 'Please select destination.';
    }
    if (
      search.origin.placeid &&
      search.destination.placeid &&
      search.origin.placeid === search.destination.placeid
    ) {
      errorsObj.destination = "Origin, Destination can't be same";
    }
    if (
      search.jdate === null ||
      search.jdate === undefined ||
      search.jdate === ''
    ) {
      errorsObj.jdate = 'Select journey date.';
    }

    setErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0) {
      return true;
    }
    const searchRequest = { ...search };
    searchRequest.jdate = formatDate(searchRequest.jdate, API_DATE_FORMAT);
    // const queryParam = `from=${searchRequest.from}&to=${searchRequest.to}&departureDate=${searchRequest.jdate}&passenger=${searchRequest.passenger}`;
    const queryParam = serialize(searchRequest);
    navigate(`${NAVIGATION_ROUTES.BUS.BUS_SEARCH}?${queryParam}`);
  };

  return (
    <div className="modify-search-page">
      <div className="modify-search-page_container">
        <div className="modify-search-page_search">
          <div className="modify-search-page_search_container p-1">
            {!isMobileWidth() ? (
              <Row className="modify-search-page_search_request spacing-8">
                <Col lg={3} md={3} sm={3} xs={6} className="position-relative">
                  <AppAsyncSelect
                    name="origin"
                    placeholder=""
                    label="From"
                    className="bus-origin-async-select"
                    components={{ Option: locationOptions }}
                    selectedValue={originRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    // defaultOptions={defaultLocationList}
                    onSelect={handleCitySelect}
                    height="54px"
                    bgColor="#FFFFFF14"
                    padding="8px 14px"
                    color="#fff"
                  />
                  <small className="validation-error">
                    {errors.origin && errors.origin}
                  </small>
                  <div className="d-flex justify-content-center origin-swap">
                    <button
                      onClick={handlePlatformSwap}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <MdOutlineSwapHoriz
                        style={{ color: appConfig?.clientPrimaryColor }}
                      />
                    </button>
                  </div>
                </Col>
                <Col lg={3} md={3} sm={3} xs={6}>
                  <AppAsyncSelect
                    name="destination"
                    placeholder=""
                    className="bus-origin-async-select"
                    label="To"
                    components={{ Option: locationOptions }}
                    selectedValue={destinationRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    onSelect={handleCitySelect}
                    height="54px"
                    bgColor="#FFFFFF14"
                    padding="8px 14px"
                    color="#fff"
                  />
                  <small className="validation-error">
                    {errors.destination && errors.destination}
                  </small>
                </Col>
                <Col lg={3} md={3} sm={3} xs={12}>
                  <AppDatePicker
                    labelClassName="landing-datepicker-label"
                    customClassName="app-modify-datepicker"
                    placeholder=""
                    label="Depart"
                    minDate={getNewDate(TODAY_DATE)}
                    monthsShown={isMobileWidth() ? 12 : 2}
                    dateFormat="dd MMM yyyy"
                    selectedDate={search.jdate}
                    onChange={(date) => handleDateChange(date, 'jdate')}
                  />
                  <small className="validation-error">
                    {errors.jdate && errors.jdate}
                  </small>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={4}
                  xs={12}
                  className="d-flex align-items-center"
                >
                  <div className="d-flex justify-content-end align-items-center flex-1">
                    <AppButton
                      variant="primary"
                      btnText="Search"
                      className="w-75"
                      onClick={handleBusSearch}
                    />
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="modify-search-page_search_request">
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="position-relative border-bottom-2"
                >
                  <AppAsyncSelect
                    name="origin"
                    placeholder="Origin"
                    label="Depart From"
                    components={{ Option: locationOptions }}
                    selectedValue={originRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                    selectedTab="bus"
                  />
                  <small className="validation-error">
                    {errors.origin && errors.origin}
                  </small>
                  <div
                    className="d-flex justify-content-center origin-swap"
                    style={{
                      top: '35px',
                      left: '45%',
                      right: 'unset',
                      position: 'absolute',
                    }}
                  >
                    <button onClick={handlePlatformSwap}>
                      <MdOutlineSwapVert
                        style={{ color: '#ed5121', marginBottom: '3px' }}
                      />
                    </button>
                  </div>
                </Col>

                <Col lg={4} md={4} sm={4} xs={12} className="border-bottom-2">
                  <AppAsyncSelect
                    name="destination"
                    placeholder=""
                    label="Going To"
                    components={{ Option: locationOptions }}
                    selectedValue={destinationRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                    menuStartFromRight={isMobileWidth()}
                    selectedTab="bus"
                  />
                  <small className="validation-error">
                    {errors.destination && errors.destination}
                  </small>
                </Col>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="my-sm-0 my-2 border-bottom-2"
                >
                  <AppDatePicker
                    className="bust-journey-date-input"
                    customClassName="app-landing-datepicker"
                    labelClassName="landing-datepicker-label"
                    label="Depart Date"
                    dateFormat="dd MMM yy"
                    minDate={getNewDate(TODAY_DATE)}
                    monthsShown={isMobileWidth() ? 12 : 2}
                    selectedDate={search.jdate}
                    onChange={(date) => handleDateChange(date, 'jdate')}
                    showDay
                  />
                  <small className="validation-error">
                    {errors.jdate && errors.jdate}
                  </small>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={4}
                  xs={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="d-flex justify-content-center service-search-btn">
                    <AppButton
                      btnText="Search Buses"
                      variant="primary"
                      onClick={handleBusSearch}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

BusSearch.defaultProps = {
  previousSearchRequest: undefined,
};

BusSearch.propTypes = {
  previousSearchRequest: PropTypes.object,
};

export default BusSearch;
